<template>
    <div>
        <b-row>
            <b-col class="mb-2" cols="12" md="6">
                <app-form-input
                    label="Código"
                    v-model.trim="document.code"
                    :has-error="$v.document.code.$error"
                    @input="$v.document.code.$touch()"
                ></app-form-input>
            </b-col>
            <b-col class="mb-2" cols="12" md="6">
                <app-form-input
                    label="Nombre"
                    v-model.trim="document.name"
                    :has-error="$v.document.name.$error"
                    @input="$v.document.name.$touch()"
                ></app-form-input>
            </b-col>
            <b-col class="mb-2" cols="12" md="6">
                <app-form-input
                    label="Versión"
                    v-model.trim="document.version"
                    :has-error="$v.document.version.$error"
                    @input="$v.document.version.$touch()"
                ></app-form-input>
            </b-col>
            <b-col class="mb-2" cols="12" md="6">
                <app-form-input
                    type="date"
                    label="Fecha de vigencia"
                    v-model="document.effectiveDate"
                ></app-form-input>
            </b-col>
            <b-col class="mb-2" cols="12">
                <app-form-textarea-input
                    label="Descripción"
                    v-model="document.description"
                ></app-form-textarea-input>
            </b-col>
            <b-col class="mb-2" cols="12">
                <label for="file">Archivo</label>
                <b-form-file
                    v-model="document.file"
                    :state="
                        $v.document.file.$dirty && $v.document.file.$error
                            ? false
                            : null
                    "
                    id="file"
                ></b-form-file>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { required, helpers } from 'vuelidate/lib/validators'
const alphaNumAndDotValidator = helpers.regex('alphaNumAndDot', /^[a-z\d.-]*$/i);
export default {
    data: () => ({
        document: {
            code: '',
            name: '',
            version: '',
            description: '',
            effectiveDate: '',
            file: null,
        },
    }),
    validations: {
        document: {
            code: { required, alphaNumAndDotValidator },
            name: { required, alphaNumAndDotValidator },
            version: { required, alphaNumAndDotValidator },
            file: { required },
        },
    },
    computed: {},
    methods: {
        save() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error('Debe diligenciar todos los campos adecuadamente')
                return false
            }

            this.$emit('save', this.document)
        },
    },
}
</script>
